import { Component, inject, OnInit, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NumberService } from '../../shared/services/number.service';
import { LeftSidebarComponent } from '../../shared/left-sidebar/left-sidebar.component';
import { ChatModalComponent } from '../../shared/chat-modal/chat-modal.component';

@Component({
  selector: 'app-daily-archive',
  standalone: true,
  imports: [DatePipe, LeftSidebarComponent, ChatModalComponent],
  templateUrl: 'daily-archive.component.html',
})
export class DailyArchiveComponent implements OnInit {
  private numberService = inject(NumberService);
  numbers = signal<any[]>([]);
  selectedNumber = signal<any | null>(null);

  ngOnInit() {
    this.loadNumbers();
  }

  loadNumbers() {
    this.numberService.getNumbersForDailyArchive().subscribe({
      next: (data) => this.numbers.set(data.numbers),
      error: (err) => console.error(err),
    });
  }

  openChat(number: any) {
    this.selectedNumber.set(number);
  }

  closeChat() {
    this.selectedNumber.set(null);
  }

  onPinged(pingedAt: string) {
    const current = this.selectedNumber();
    if (!current) {
      return;
    }
    this.numbers.update((numbers) =>
      numbers.map((number) =>
        number.number_id === current.number_id && number.provider_code_id === current.provider_code_id
          ? { ...number, pinged_at: pingedAt }
          : number,
      ),
    );
    this.selectedNumber.update((number) => (number ? { ...number, pinged_at: pingedAt } : number));
  }
}